module.exports = __webpack_public_path__ + "h5/img/service4.f539d6e6.png";